$(document).ready(function() {
    $(document).on('click', '.hamburger', function() {
       $('.mobile-megamenu').toggleClass('open-menu');
       $('.overlay-content').toggleClass('open-overlay');
        $('body').toggleClass('opened-drawer');
   });
   $(document).on('click', '.close-menu', function() {
      $('.mobile-megamenu').removeClass('open-menu');
      $('.overlay-content').removeClass('open-overlay');
       $('body').removeClass('opened-drawer');
   });
});